/**
 * @category Error
 */
export class BeaconError {
    name = 'BeaconError';
    message;
    title = 'Error'; // Visible in the UI
    description; // Visible in the UI
    get fullDescription() {
        return { description: this.description };
    }
    constructor(errorType, message) {
        this.message = `[${errorType}]:${message}`;
        this.description = message;
    }
}
//# sourceMappingURL=BeaconError.js.map